import React from "react";
import "../OpalAccountInfoDetails.css";

const OpalAccountCoverage = ({ data }) => {
    return (
        <div className="opal-info-details">
            <div className="opal-row">
                <div className="opal-cell label">Visit Freq.</div>
                <div className="opal-cell value">{data?.frequency?.code}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Time to Visit</div>
                <div className="opal-cell value">{data?.bestTime?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Days to Visit</div>
                <div className="opal-cell value">{data?.bestDay?.code}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Ref. Code</div>
                <div className="opal-cell value">{data?.referenceCode}</div>
            </div>
        </div>
    );
};

export default OpalAccountCoverage;
